var file_upload_viewer_default = {
  "fontElementMap": "_6ZiIq",
  "file_upload_container": "_5nsIa",
  "file_upload_link": "khKE-",
  "file_upload_error_container": "DqNkP",
  "file_upload_file_info": "YkmgH",
  "file_upload_type_icon": "X-gsA",
  "file_upload_status_icon_container": "_0QAL7",
  "file_upload_status_icon": "TzkMY",
  "file_upload_description": "Yl02z",
  "file_upload_name_container": "Fe---",
  "file_upload_name": "BRouT",
  "file_upload_extension": "zv--e",
  "file_loader_icon": "Vtpao",
  "file_upload_icon_frame": "SysEh",
  "file_upload_icon_background": "_0iuTL"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
